import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
import Container from './views/Container.vue'
import weui from 'weui.js';

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'container',
      component: Container,
      children: [{
        path: '/login',
        name: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "recharge" */ './views/Login.vue')
      },{
        path: '/recharge',
        name: 'recharge',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "recharge" */ './views/Recharge.vue')
      },{
        path: '/mine',
        name: 'mine',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "mine" */ './views/Mine.vue')
      },{
        path: '/history',
        name: 'history',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "mine" */ './views/History.vue')
      },{
        path: '/use_history',
        name: 'use_history',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "mine" */ './views/UseHistory.vue')
      }]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path == '/login'){
    next()
    return
  }
  // if(to.path == '/use_history'){
  //   next()
  //   return
  // }
  if(!store.state.user.currentUser.id) {
    weui.alert("请先登录", {
      className: "fm-border"
    })
    next("/login")
    return
  }
  if(to.path != '/mine' && !store.state.user.currentUser.room){
    next("/mine")
    return
  }
  next()
})

export default router